import { render, staticRenderFns } from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=template&id=4b07fc62"
import script from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraVisualizarPedidosDeCompraView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports